export default "__VITE_ASSET__OT$axO3S__"